import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface SendOfflineSupplierEmailVerificationVariables {
  offlineSupplierId: number;
  skipInvalidate?: boolean;
}

const sendOfflineSupplierEmailVerification = async ({
  offlineSupplierId,
}: SendOfflineSupplierEmailVerificationVariables): Promise<void> => {
  await axiosInstance.post(api.sendOfflineSupplierEmailVerification(offlineSupplierId));
};

const useSendOfflineSupplierEmailVerificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendOfflineSupplierEmailVerification,
    onSuccess: (_data, { skipInvalidate }) => {
      if (skipInvalidate) {
        return;
      }

      queryClient.invalidateQueries({ queryKey: queryKeys.manageSuppliers.root });
    },
  });
};

export default useSendOfflineSupplierEmailVerificationMutation;
